import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { ICONS } from '../../../../_helpers/icons.constants';

@Component({
  selector: 'status-renderer',
  templateUrl: './status-renderer.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class StatusRenderComponent implements ICellRendererAngularComp {
  public text: string = '';
  public status: any;
  public ICONS = ICONS;
  public isBullet: boolean = true;
  public isPinned: boolean = false;

    private statusConfig = [
        { id: 1, type: 'primary' }, //blue
        { id: 2, type: 'success' }, //green
        { id: 3, type: 'pending' }, //yellow
        { id: 4, type: 'incomplete' }, //red
        { id: 5, type: 'not-enabled' }, //gray,
        { id: 6, type: 'accent' },
        { id: 7, type: 'secondary' },
    ];
  constructor() { }


  initilize(params: ICellRendererParams) {
    this.status = params.getValue();
    this.isPinned = params?.node?.rowPinned === 'bottom';
    if (this.status) {
      this.text = this.statusConfig.find(item => item.id === this.status.statusType)?.type;
    }
    this.isBullet = params?.colDef?.headerComponentParams?.isBullet
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}
